import { useMutation } from '@tanstack/react-query';
import { getLiveSearchAutoSubmit, getLiveSearchFill, postLiveSearchResults } from './liveSearchService';

export const LIVE_SEARCH_MUTATION_KEY = 'liveSearch';
export const LIVE_SEARCH_AUTO_SUBMIT_MUTATION_KEY = 'liveSearchAutoSubmit';
export const LIVE_SEARCH_FILL_MUTATION_KEY = 'liveSearchFill';

/**
 * Live search POST mutation
 * @param {import('@tanstack/react-query').UseMutationOptions<ApiLiveSearchResponse, Error, {searchUrl: string, body: ApiLiveSearchRequest}, unknown>} [options]
 * @returns {import('@tanstack/react-query').UseMutationResult<ApiLiveSearchResponse, Error, {searchUrl: string, body: ApiLiveSearchRequest}, unknown>}
 */
export const useLiveSearchMutation = (options = {}) => useMutation({
  mutationKey: [LIVE_SEARCH_MUTATION_KEY],
  mutationFn: ({ searchUrl, body }) => postLiveSearchResults(searchUrl, body),
  ...options,
});

/**
 * Live search auto-submit GET mutation
 * @param {import('@tanstack/react-query').UseMutationOptions<ApiFormPostResponse, Error, string, unknown>} [options]
 * @returns {import('@tanstack/react-query').UseMutationResult<ApiFormPostResponse, Error, string, unknown>}
 */
export const useLiveSearchAutoSubmitMutation = (options = {}) => useMutation({
  mutationKey: [LIVE_SEARCH_AUTO_SUBMIT_MUTATION_KEY],
  mutationFn: (autoSubmitUrl) => getLiveSearchAutoSubmit(autoSubmitUrl),
  ...options,
});

/**
 * Live search fill GET mutation
 * @param {import('@tanstack/react-query').UseMutationOptions<ApiLiveSearchFillResponse, Error, string, unknown>} [options]
 * @returns {import('@tanstack/react-query').UseMutationResult<ApiLiveSearchFillResponse, Error, string, unknown>}
 */
export const useLiveSearchFillMutation = (options = {}) => useMutation({
  mutationKey: [LIVE_SEARCH_FILL_MUTATION_KEY],
  mutationFn: (fieldsUrl) => getLiveSearchFill(fieldsUrl),
  ...options,
});
